import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-c-one-two-one-one',
  templateUrl: './c-one-two-one-one.component.html',
  styleUrls: ['./c-one-two-one-one.component.scss']
})
export class COneTwoOneOneComponent implements OnInit {
  pdfSrc: string[] = [
    '/assets/pdf/NAAC/Criterion 1/1.2.1.1_Addon Courses Attendance/2021-22 _Addon Courses Attendance.pdf', 
    '/assets/pdf/NAAC/Criterion 1/1.2.1.1_Addon Courses Attendance/2020-21 _Addon Courses Attendance.pdf', 
    '/assets/pdf/NAAC/Criterion 1/1.2.1.1_Addon Courses Attendance/2019-20 _Addon Courses Attendance.pdf', 
    '/assets/pdf/NAAC/Criterion 1/1.2.1.1_Addon Courses Attendance/2018-19 _Addon Courses Attendance.pdf', 
    '/assets/pdf/NAAC/Criterion 1/1.2.1.1_Addon Courses Attendance/2017-18_Addon Courses Attendance.pdf', ];
  src: string;

  isLoading = true;
  constructor() { }

  ngOnInit(): void {
    this.changeRoute('1');
  }

  changeRoute(year: string) {
    this.isLoading = true;
    if (year == '1') {
      $('.first').addClass('active');
      $('.second').removeClass('active');
      $('.third').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[0];
    }
    if (year == '2') {
      $('.second').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[1];
    }
    if (year == '3') {
      $('.third').addClass('active');
      $('.first').removeClass('active');
      $('.second').removeClass('active');
      $('.fourth').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[2];
    }
    if (year == '4') {
      $('.fourth').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.second').removeClass('active');
      $('.fifth').removeClass('active');
      this.src = this.pdfSrc[3];
    }
    if (year == '5') {
      $('.fifth').addClass('active');
      $('.first').removeClass('active');
      $('.third').removeClass('active');
      $('.second').removeClass('active');
      $('.fourth').removeClass('active');
      this.src = this.pdfSrc[4];
    }
    
    

  }
  hideLoader() {
    this.isLoading = false;
  }
}
